import { __awaiter, __generator, __read } from "tslib";
import { fetchSearchCenterUrlFromBackendInternal, getSearchCenterUrlFromCache, } from '.';
export function getSearchCenterUrl(searchPrefetch, searchSettings, searchHostAppLogger) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, tokenProviders, identity, userEntitlements, prefetchModule, isMsa, fetchSearchCenterUrl, sharePointTokenProvider, fetchSearchCenterUrlFromBackend, refreshCache, searchCenterUrl, searchCenterUrlFromCache, searchCenterUrlFromBackend;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        searchSettings.getTokenProviders(),
                        searchSettings.getIdentity(),
                        searchSettings.getUserEntitlements(),
                        searchPrefetch.getModule(),
                    ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 4]), tokenProviders = _a[0], identity = _a[1], userEntitlements = _a[2], prefetchModule = _a[3];
                    isMsa = identity.isMsa;
                    fetchSearchCenterUrl = prefetchModule.fetchSearchCenterUrl;
                    sharePointTokenProvider = tokenProviders.sharePointTokenProvider;
                    if (isMsa) {
                        // sharePointTokenProvider is not supported in MSA.
                        return [2 /*return*/, undefined];
                    }
                    fetchSearchCenterUrlFromBackend = function () {
                        return fetchSearchCenterUrlFromBackendInternal(fetchSearchCenterUrl, {
                            sharePointResourceId: userEntitlements.SharePointResourceId || '',
                            sharePointTokenProvider: sharePointTokenProvider,
                        });
                    };
                    refreshCache = false;
                    searchCenterUrlFromCache = getSearchCenterUrlFromCache();
                    /**
                     * If it's cached in localStorage, use that value.
                     *
                     * Since it was cached, we want to fire an update call to the backend
                     * which is not awaited, hence setting refreshCache to true
                     */
                    if (searchCenterUrlFromCache) {
                        searchCenterUrl = searchCenterUrlFromCache;
                        refreshCache = true;
                    }
                    if (!!searchCenterUrlFromCache) return [3 /*break*/, 3];
                    return [4 /*yield*/, fetchSearchCenterUrlFromBackend()];
                case 2:
                    searchCenterUrlFromBackend = _b.sent();
                    searchCenterUrl = searchCenterUrlFromBackend;
                    /**
                     * In this case, we have the fresh value so we do not
                     * want to trigger an unawaited call to the backend
                     */
                    refreshCache = false;
                    _b.label = 3;
                case 3:
                    if (refreshCache) {
                        fetchSearchCenterUrlFromBackend().then(function (searchCenterUrlFromBackend) {
                            searchCenterUrl = searchCenterUrlFromBackend;
                        });
                    }
                    searchHostAppLogger.setSearchCenterUrlReferral(searchCenterUrl);
                    return [2 /*return*/, searchCenterUrl];
            }
        });
    });
}
//# sourceMappingURL=getSearchCenterUrl.js.map